import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, LogIn, ShieldCheck, Github } from 'lucide-react'; // Using lucide-react for icons



const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [walletApi, setWalletApi] = useState(null);

  const connectWallet = async () => {
    try {
      const api = await window.midnight.mnLace.enable();
      setWalletApi(api);
      
      const state = await api.state();

      if (state?.address) {
        localStorage.setItem('xenios_cyberguard_token', 'mock_token');
        navigate('/main-dashboard', { replace: true });
      }
    } catch (err) {
      setError('Failed to connect wallet: ' + err.message);
    }
  };

  const handleMockLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    connectWallet();
    setError('');
    localStorage.setItem('xenios_cyberguard_token', 'mock_token');
    navigate('/main-dashboard', { replace: true });
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    connectWallet();
    // try {
    //     const response = await fetch(`${import.meta.env.VITE_APP_SERVER_URL}/user/login`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ email, password })
    //     });

    //     const data = await response.json();

    //     if (data.token) {
    //         localStorage.setItem('xenios_cyberguard_token', data.token);
    //         navigate('/main-dashboard', { replace: true });
    //     } else {
    //         setError('Invalid email or password.');
    //     }
    // } catch (error) {
    //     setError('Invalid email or password.');  
    // } finally {
    //   setIsLoading(false);
    // }
   
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-sm p-8 space-y-8 bg-card rounded-lg border border-border shadow-medium">
        <div className="flex flex-col items-center space-y-2">
          <div className="flex items-center justify-center w-12 h-12 mb-2 bg-primary text-primary-foreground rounded-lg">
            <ShieldCheck size={28} />
          </div>
          <h2 className="text-2xl font-semibold text-center text-foreground">
            Sign In to CyberGuard
          </h2>
          <p className="text-sm text-center text-muted-foreground">
            Enter your credentials to access the dashboard.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          {error && (
            <div className="p-3 text-sm text-center text-destructive-foreground bg-destructive rounded-md">
              {error}
            </div>
          )}
          {/* <div>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
                <Mail size={18} />
              </span>
              <input
                id="email"
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input pl-10"
                disabled={isLoading}
              />
            </div>
          </div>
          <div>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
                <Lock size={18} />
              </span>
              <input
                id="password"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input pl-10"
                disabled={isLoading}
              />
            </div>
          </div>
          
          <button
            type="submit"
            className="w-full flex items-center justify-center btn bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50"
            disabled={isLoading}
          >
            {isLoading ? (
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary-foreground" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            ) : (
              <><LogIn size={18} className="mr-2" /> Sign In</>
            )}
          </button> */}
        </form>

        <button
          type="submit"
          className="w-full flex items-center justify-center btn bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50"
          disabled={isLoading}
          onClick={handleLogin}
        >
          {isLoading ? (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary-foreground" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            <><LogIn size={18} className="mr-2" /> Wallet Sign In</>
          )}
        </button>

        <button
          type="submit"
          className="w-full flex items-center justify-center btn bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50"
          disabled={isLoading}
          onClick={handleMockLogin}
        >
          {isLoading ? (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary-foreground" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            <><LogIn size={18} className="mr-2" /> Mock Sign In</>
          )}
        </button>

        {/* <div className="flex flex-col items-center space-y-2 text-sm">
          <a href="#" className="text-primary hover:underline">
            Forgot password?
          </a>
          <p className="text-muted-foreground">
            Don't have an account? <a href="#" className="text-primary hover:underline">Sign up</a>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;
